import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcab5e32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "app-editor-toolbar-warp d-flex-1f d-flex" }
const _hoisted_3 = { class: "app-editor-toolbar-teim-warp" }
const _hoisted_4 = { class: "app-editor-toolbar-teim-warp" }

import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppEditor',
  props: {
    modelValue: String,
    max: {
        type: Number,
        default: 2000
    }
},
  emits: ["update:modelValue", "update:editorText"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props


const editorRef = ref<HTMLDivElement>();
const editorInputRef = ref<HTMLDivElement>();
const len = ref(0);
const fullScreenState = ref(false);
onMounted(() => {
    console.log(editorInputRef);
});
const emits = __emit;
// const showText = ref("");

const handleInput = () => {
    emits("update:modelValue", editorInputRef.value.innerHTML);
    emits("update:editorText", editorInputRef.value.innerText);


    len.value = editorInputRef.value.innerText.trim().length;
};
// return { showText, handleSelection };

function insertImg() {
    console.error('asdf');
}

const parentNode = ref<HTMLDivElement>();

function handleFullScreen() {
    const body = document.querySelector("body");
    if (!fullScreenState.value) {
        parentNode.value = parentNode.value || editorRef.value.parentNode as HTMLDivElement;

        // 显示
        const parentNodeTag = (editorRef.value.parentNode as HTMLElement)?.tagName;
        if (parentNodeTag != "body") {
            // 未加入，body，选择加入
            if (body.append) {
                body.append(editorRef.value);
            } else {
                body.appendChild(editorRef.value);
            }
        }
    } else {
        // 隐藏
        parentNode.value.append(editorRef.value);
        // body.removeChild(body.lastChild);
    }
    fullScreenState.value = !fullScreenState.value;
}
/**
 * 验证函数是否正确
 */
const validateLen = () => {
    return len.value <= props.max;
}

__expose({
    validateLen
});

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-editor d-flex-column", { 'full-screen': fullScreenState.value }]),
    ref_key: "editorRef",
    ref: editorRef
  }, [
    _createElementVNode("div", {
      class: "app-editor-input d-flex-1f",
      onInput: handleInput,
      ref_key: "editorInputRef",
      ref: editorInputRef,
      contenteditable: "true"
    }, null, 544),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_icon, {
            name: "photo-o",
            size: "30",
            onClick: insertImg
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_icon, {
            name: "video-o",
            size: "30"
          })
        ]),
        _createElementVNode("div", {
          class: "app-editor-toolbar-teim-warp",
          onClick: handleFullScreen
        }, [
          _withDirectives(_createVNode(_component_van_icon, {
            name: "shrink",
            size: "30"
          }, null, 512), [
            [_vShow, fullScreenState.value]
          ]),
          _withDirectives(_createVNode(_component_van_icon, {
            name: "expand-o",
            size: "30"
          }, null, 512), [
            [_vShow, !fullScreenState.value]
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["app-editor-word-num-warp", {err:len.value>__props.max}])
      }, _toDisplayString(len.value) + "/" + _toDisplayString(__props.max), 3)
    ])
  ], 2))
}
}

})